import { LanguageId } from 'src/app/types/language.type';
import { AprimoVideo } from 'src/app/shared/utils/aprimo-video.util';

const APRIMO_BASE = 'https://p1.aprimocdn.net/resmed';

const EN_US = `${APRIMO_BASE}/ce9e846e-b086-4a4c-99eb-b44700725ba0/video:-welcome-to-myair-original-file.mp4`;
const EN_GB = `${APRIMO_BASE}/b6ef6b07-09c5-4986-aaf5-b44700766d35/video:-welcome-to-myair-global-english-original-file.mp4`;
const FR = `${APRIMO_BASE}/b9960e99-59b7-4dac-8e99-b447007ba25b/video:-patient-journey-french-original-file.mp4`;
const DE = `${APRIMO_BASE}/0fa45177-8c88-4ba6-84a8-b4470072c762/video:-welcome-to-myair-german-original-file.mp4`;

/**
 * Aprimo assets for the homepage welcome video, taken from ContentStack entry SC1020Y.
 *
 * The homepage is pre-login, so there is no API path to read ContentStack at runtime. The assets
 * are public on the Aprimo CDN and identical across environments, so they are configured here
 * rather than per environment. These replace the retired Brightcove ids (EnglishUk 5767444222001,
 * French 5792096477001, German 4122376555001, default 4057741595001).
 *
 * Every other language falls back to `default`. Backend and mobile serve the US cut to every
 * locale except en-GB (see rmd_strings `welcome_to_myair_video_url`), so web matches that.
 */
export const WELCOME_VIDEOS: Partial<Record<LanguageId | 'default', AprimoVideo>> = {
  EnglishUs: { videoUrl: EN_US, subtitles: [] },
  EnglishUk: { videoUrl: EN_GB, subtitles: [] },
  French: { videoUrl: FR, subtitles: [] },
  German: { videoUrl: DE, subtitles: [] },
  default: { videoUrl: EN_US, subtitles: [] },
};

export const WELCOME_VIDEO_POSTER = `${APRIMO_BASE}/7d2de5e4-6d10-4daf-a98c-b45d00ae06ad/video-thumbnail-welcome-to-myair-original-file.jpg`;

export function getWelcomeVideo(languageId: LanguageId): AprimoVideo | null {
  return WELCOME_VIDEOS[languageId] || WELCOME_VIDEOS.default || null;
}
